function initSuntekTestimonialsSlider(root) {
  if (!root || root.dataset.suntekTestimonialsInitialized === 'true') return;

  const viewport = root.querySelector('[data-testimonial-viewport]');
  const track = root.querySelector('[data-testimonial-track]');
  const prev = root.querySelector('[data-testimonial-prev]');
  const next = root.querySelector('[data-testimonial-next]');
  const dotsContainer = root.parentElement ? root.parentElement.querySelector('[data-testimonial-dots]') : null;

  if (!viewport || !track || !prev || !next || !dotsContainer) return;

  const slides = Array.from(track.children);
  const dots = Array.from(dotsContainer.querySelectorAll('[data-index]'));
  const total = slides.length;

  if (!total) return;

  let current = 0;

  const update = (instant = false) => {
    if (!total) return;

    slides.forEach((slide, index) => {
      const isCurrent = index === current;
      const isPrev = index === (current - 1 + total) % total;
      const isNext = index === (current + 1) % total;

      slide.classList.toggle('is-current', isCurrent);
      slide.classList.toggle('is-prev', isPrev);
      slide.classList.toggle('is-next', isNext);
      slide.setAttribute('aria-hidden', String(!isCurrent));
    });

    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === current);
    });

    const previousTransition = track.style.transition;
    if (instant) {
      track.style.transition = 'none';
    }

    track.style.transform = 'none';
    const viewportRect = viewport.getBoundingClientRect();
    const currentSlide = slides[current];

    if (currentSlide) {
      const slideRect = currentSlide.getBoundingClientRect();
      const offset =
        slideRect.left - viewportRect.left + slideRect.width / 2 - viewportRect.width / 2;

      track.style.transform = `translateX(${offset * -1}px)`;
    }

    if (instant) {
      track.getBoundingClientRect();
      track.style.transition = previousTransition;
    }
  };

  const goTo = (index, options) => {
    const instant = options && options.instant === true;
    if (!total) return;
    const normalized = ((index % total) + total) % total;
    if (normalized === current) return;
    current = normalized;
    update(instant);
  };

  prev.addEventListener('click', () => {
    goTo(current - 1);
  });

  next.addEventListener('click', () => {
    goTo(current + 1);
  });

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const index = parseInt(dot.dataset.index || '0', 10);
      if (Number.isNaN(index)) return;
      goTo(index);
    });
  });

  const handleResize = () => {
    update(true);
  };

  window.addEventListener('resize', handleResize);

  root.dataset.suntekTestimonialsInitialized = 'true';
  root.suntekTestimonials = { goTo };

  update(true);
}

function initAllSuntekTestimonialsSliders(container) {
  const scope = container || document;
  const sliders = scope.querySelectorAll('[data-suntek-testimonials]');
  sliders.forEach((slider) => initSuntekTestimonialsSlider(slider));
}

document.addEventListener('DOMContentLoaded', () => {
  initAllSuntekTestimonialsSliders();
});

document.addEventListener('shopify:section:load', (event) => {
  if (!(event.target instanceof HTMLElement)) return;
  initAllSuntekTestimonialsSliders(event.target);
});

document.addEventListener('shopify:block:select', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLElement)) return;

  const slider = target.closest('[data-suntek-testimonials]');
  if (!slider || !slider.suntekTestimonials) return;

  const slideEl = target.closest('[data-index]');
  if (!slideEl) return;

  const indexAttr = slideEl.getAttribute('data-index');
  if (indexAttr == null) return;

  const index = parseInt(indexAttr, 10);
  if (Number.isNaN(index)) return;

  slider.suntekTestimonials.goTo(index, { instant: true });
});

